






























import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import RequestButton from '@/components/RequestButton'
import SetAccountManagerTrigger from './SetAccountManagerTrigger.coffee'

settings =
  name: 'SetAccountManagerTriggerModal'

  resources:
    super_users:
      resourceName: 'super_users'
      slug: 'super_users'
      params:
        limit: 1000

  vue:
    props: ['resourceComponent', 'resourceKey']
    components: { Modal, RequestButton }
    mixins: [SetAccountManagerTrigger.trigger()]

    computed:
      modalConfig: -> @modal.config || {}

      filteredSuperUsers: ->
        (@super_users || []).filter((user) => user.email isnt @modalConfig.currentAccountManager)

export default VueOptions.vue settings
